import {Address} from './address';

export class Regulator {
    id:string;
    name:string;
    address:Address;
    hasAgreement:boolean;
    phone:string;

    constructor(other ?:Regulator) {
        if (other) {
            this.id = other.id;
            this.name = other.name;
            this.address = new Address(other.address);
            this.hasAgreement = other.hasAgreement;
            this.phone = other.phone;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/regulator.ts
 **/